module.exports = __webpack_public_path__ + "img/argentina.f18eda37.png";